import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/verify/pages/Verify'
import { VerifyRoutePathsEnum } from '@/modules/verify/routes/verifyRouteConfig.types'

export const VERIFY_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: VerifyRoutePathsEnum.EMAIL_VERIFY,
  },
]
